import { forwardRef } from "react";
import SceneFrame from "./SceneFrame";
import { getSceneImageProps } from "../sceneAssets";

const Scene6 = forwardRef(function Scene6({ copy, language, isArabic, breakpoint = "desktop" }, ref) {
  const { imageSrc, imageSrcSet, imageSizes } = getSceneImageProps(6, breakpoint);
  return (
    <SceneFrame
      ref={ref}
      sceneId={6}
      imageSrc={imageSrc}
      imageSrcSet={imageSrcSet}
      imageSizes={imageSizes}
      copy={copy}
      language={language}
      isArabic={isArabic}
    />
  );
});

export default Scene6;
